module.exports = __webpack_public_path__ + "img/beidou.4506047a.png";